import React, { memo } from "react";
import { MdGridView, MdViewList } from "react-icons/md";

const ViewToggle = ({ isGridView, onToggle }) => {
  return (
    <>
      <button
        onClick={() => onToggle(false)}
        className={`rounded-lg p-2.5 transition-all ${
          !isGridView
            ? "bg-[#57A863] text-white shadow-md"
            : "bg-gray-200 hover:bg-gray-300"
        }`}
        aria-label="Vue liste"
        title="Vue liste"
      >
        <MdViewList className="text-xl" />
      </button>
      <button
        onClick={() => onToggle(true)}
        className={`rounded-lg p-2.5 transition-all ${
          isGridView
            ? "bg-[#57A863] text-white shadow-md"
            : "bg-gray-200 hover:bg-gray-300"
        }`}
        aria-label="Vue grille"
        title="Vue grille"
      >
        <MdGridView className="text-xl" />
      </button>
    </>
  );
};

export default memo(ViewToggle);
